/**
 * Calmy mobile menu — category tabs.
 *
 * The panel's open/close, scroll lock, focus trap, Escape and focus return all
 * belong to calmy-core.js and are untouched. This file only switches panels.
 *
 * NO DUPLICATE HANDLERS: each tablist carries its own flag, so a theme-editor
 * section reload re-running boot() over an already-wired menu is a no-op, and
 * a second menu instance gets its own independent wiring.
 */
(function () {
  "use strict";

  var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)");

  function init(tabs) {
    if (tabs.__calmyMenu) return;
    tabs.__calmyMenu = true;

    var panel = tabs.closest("[data-calmy-nav]") || document;
    var list = Array.prototype.slice.call(tabs.querySelectorAll('[role="tab"]'));
    if (!list.length) return;

    /* The heading row between the tabs and the products. It is rendered by
       Liquid for the first tab and already carries a real href, so everything
       below only has to keep it in step with the tab that is showing. */
    var catName = panel.querySelector("[data-calmy-menu-catname]");
    var catLink = panel.querySelector("[data-calmy-menu-catlink]");
    var catAll = panel.querySelector("[data-calmy-menu-catall]");

    function lead(p) {
      if (!p) return;
      var d = p.dataset || {};
      if (catName && d.catName) catName.textContent = d.catName;
      if (catAll && d.catAll) catAll.textContent = d.catAll;
      /* setAttribute, not .href: a relative path assigned through .href is
         read back absolute, and an empty value would silently become the
         current page. */
      if (catLink && d.catUrl) catLink.setAttribute("href", d.catUrl);
    }

    function panelFor(tab) {
      return panel.querySelector("#" + tab.getAttribute("aria-controls"));
    }

    function select(tab, focusIt) {
      list.forEach(function (t) {
        var on = t === tab;
        t.classList.toggle("is-on", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
        /* Roving tabindex: one stop for the whole tablist, arrows move within
           it. Without this every tab is a separate tab stop. */
        t.setAttribute("tabindex", on ? "0" : "-1");
        var p = panelFor(t);
        if (!p) return;
        if (on) {
          p.hidden = false;
          /* The fade is added after the panel is displayed so it runs; the
             class is removed on the way out so a re-entry animates again. */
          if (!REDUCED.matches) {
            p.classList.remove("is-in");
            void p.offsetWidth;
            p.classList.add("is-in");
          }
          p.classList.add("is-on");
          lead(p);
        } else {
          p.hidden = true;
          p.classList.remove("is-on", "is-in");
        }
      });

      /* Bring the chosen tab fully into view — the row scrolls, and a tab
         selected by keyboard can be off-screen. */
      if (tab.scrollIntoView) {
        try {
          tab.scrollIntoView({
            inline: "center",
            block: "nearest",
            behavior: REDUCED.matches ? "auto" : "smooth"
          });
        } catch (e) { /* older engines: the non-options form is enough */
          tab.scrollIntoView();
        }
      }
      if (focusIt) tab.focus();
    }

    tabs.addEventListener("click", function (e) {
      var t = e.target.closest && e.target.closest('[role="tab"]');
      if (t) select(t, false);
    });

    /* The products area scrolls, and the tab row scrolls sideways. Both are
       reset when the drawer is opened again so it never reopens halfway down
       the previous category, and the selected tab is brought back into view on
       a narrow phone where the row is wider than the screen. */
    function reveal() {
      var body = panel.querySelector("[data-calmy-nav-body]");
      if (body) body.scrollTop = 0;
      var on = tabs.querySelector('[role="tab"].is-on') || list[0];
      if (!on) return;
      if (tabs.scrollWidth > tabs.clientWidth) {
        /* scrollLeft rather than scrollIntoView: the panel is mid-transition
           and scrollIntoView would drag the whole page toward it. */
        tabs.scrollLeft = Math.max(0, on.offsetLeft - (tabs.clientWidth - on.offsetWidth) / 2);
      }
      lead(panel.querySelector('.cmenu__panel.is-on'));
    }

    /* calmy-core toggles .is-on on the panel when it opens it; there is no
       event to listen for, so the class is watched instead. Cheap - one
       attribute on one element - and it cannot double up, because the observer
       is created once behind the same __calmyMenu guard as everything else. */
    if (window.MutationObserver && panel !== document) {
      var wasOn = panel.classList.contains("is-on");
      new MutationObserver(function () {
        var now = panel.classList.contains("is-on");
        if (now && !wasOn) reveal();
        wasOn = now;
      }).observe(panel, { attributes: true, attributeFilter: ["class"] });
    }

    tabs.addEventListener("keydown", function (e) {
      var i = list.indexOf(document.activeElement);
      if (i < 0) return;
      var n = null;
      if (e.key === "ArrowRight") n = list[(i + 1) % list.length];
      else if (e.key === "ArrowLeft") n = list[(i - 1 + list.length) % list.length];
      else if (e.key === "Home") n = list[0];
      else if (e.key === "End") n = list[list.length - 1];
      if (!n) return;
      e.preventDefault();
      select(n, true);
    });
  }

  function boot(root) {
    (root || document).querySelectorAll("[data-calmy-menu-tabs]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(); });
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
  /* calmy-core portals the panel to <body>, which moves the node but does not
     clone it, so the flag and the listeners travel with it. */
})();
